<template>
    <div>
      <div style="background: white" v-if="loading">
        <VueContentLoading
            :width="350"
            :height="400"
            :speed="1"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
        >
          <rect x="2" y="7" rx="2" ry="2" width="392" height="392" />
        </VueContentLoading>
      </div>

        <div class="matchNotfound alert alert-danger mx-2" v-if="matchNotfound && !loading">
            {{ t.fixture.odd_notfound }}
        </div>

        <template v-if="match">
           <!-- <scoreboard layout="double" :match="match" :matchId.sync="match.rid" v-if="!match.streamEmbed" /> !-->
            <!--end odd head -->
            <div class="" v-if="match.odds" :id="'oh'+match.matchId">
              <div class="CollapsibleItem-styles-collapsible-item Category-styles-category-header"
                   v-for="c in category" v-if="finded.includes(c.id) || c.id == 0">

                <div class="Category-styles-header-wrapper">
                  <div class="CategoryHeader-styles-category-header-container" @click="collapse(c)">
                    <div id="category-undefined" class="CategoryHeader-styles-category-title-container">
                      <span>{{ c.name }}</span>
                    </div>
                    <div class="CategoryHeader-styles-arrow-container"
                    :class="(c.collapsed) ? 'CategoryHeader-styles-open' : ''">
                      <img src="/static/assets/img/arrow-up.svg" alt="program.rightArrow">
                    </div>
                  </div>
                </div>
                <div class="" v-if="c.collapsed">
                  <div class="OddGroups-styles-event-details-odds-groups">
                    <template v-for="list in ReList()">
                        <template v-for="odd in sortAByKey(list.markets, 'sp')">
                            <template v-if="odd.oddl && odd.odd.length >= odd.minodd">
                                <market :market="odd" :match="match"
                            v-if="odd.odd && odd.markets && odd.markets.includes(c.id) || c.id === 0" />
                            </template>
                            <template v-if="!odd.oddl">
                                <market :market="odd" :match="match"
                            v-if="odd.odd && odd.markets && odd.markets.includes(c.id) || c.id === 0" />
                            </template>
                        </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
        </template>
    </div>
</template>

<script>
    import VueContentLoading from 'vue-content-loading';
    import oddHeader from '@/components/sportsbook/oddHeader'
    import betSlip from '@/mixins/betSlip'
    import spinalLoader from '@/components/ui/loader/spinalLoader.vue'
    import oddHead from "./oddHead";
    import market from './market/market'
    import fixture from '../../mixins/fixture';

    export default {
        name: 'odd',
        components: {VueContentLoading, spinalLoader, oddHead, oddHeader, market},
        mixins: [betSlip,fixture],
        data() {
            return {
                t: this.$root.t,
                odds: null,
                matchNotfound: false,
                loading: true,
                selectedOdds: [],
                viewPort: 'list',
                marketType: 0,
                re: 0,
                syncStat: true,
                empty: false,
                stickyEnabled: true,
                category: [
                {name: this.$root.t.main_markets, id: 1, i: 'entypo-icon-tv', collapsed: true},
                {name: this.$root.t['1st_half'], id: 14, i: 'entypo-icon-circular-graph', collapsed: false},
                {name: this.$root.t['2nd_half'], id: 16, i: 'entypo-icon-circle', collapsed: false},
                {name: 'Fav', id: 111, i: 'entypo-icon-shield', collapsed: false},
                {name: this.$root.t.handicap_markets, id: 17, i: 'entypo-icon-resize-full-screen', collapsed: false},
                {name: this.$root.t.total_markets, id: 15, i: 'entypo-icon-code', collapsed: false},
                {name: this.$root.t['1st_quarter'], id: 21, i: 'ti-time', collapsed: true},
                {name: this.$root.t['2nd_quarter'], id: 22, i: 'ti-time', collapsed: true},
                {name: this.$root.t['3rd_quarter'], id: 23, i: 'ti-time', collapsed: true},
                {name: this.$root.t['4th_quarter'], id: 24, i: 'ti-time', collapsed: true},
                {name: this.$root.t['1st_period'], id: 30, i: 'ti-time', collapsed: true},
                {name: this.$root.t['2nd_period'], id: 31, i: 'ti-time', collapsed: true},
                {name: this.$root.t['3rd_period'], id: 32, i: 'ti-time', collapsed: true},
                {name: 'Specials', id: 190, i: 'entypo-icon-popup', collapsed: false},
                {name: this.$root.t['corner_markets'], id: 2, i: 'entypo-icon-popup', collapsed: false},
                {name: this.$root.t['player_markets'], id: 53, i: 'entypo-icon-user', collapsed: false},
                {name: this.$root.t['foul_markets'], id: 100, i: 'entypo-icon-notification', collapsed: false},
                {name: this.$root.t['throwin_markets'], id: 100, i: 'entypo-icon-align-vertical-middle', collapsed: false},
                {name: this.$root.t['card_markets'], id: 33, i: 'entypo-icon-documents', collapsed: false},
                {name: this.$root.t['shot_markets'], id: 100, i: 'entypo-icon-vinyl', collapsed: false},
                {name: this.$root.t['offside_markets'], id: 100, i: 'entypo-icon-flag', collapsed: false},
                {name: this.$root.t['substitutions_markets'], id: 100, i: 'entypo-icon-swap', collapsed: false},
                {name: this.$root.t['ball_possession_markets'], id: 100, i: 'entypo-icon-shareable', collapsed: false},
                {name: this.$root.t['other_markets'], id: 18, i: 'entypo-icon-dots-three-horizontal', collapsed: false},
                {name: this.$root.t['all_markets'], id: 0, i: 'icon-grid', collapsed: false},
                ],
              finded: [],
            }
        },
        props: {
            match: {
              default: 0,
            },
            matchId: {
                default: 0,
            },
            live: {
                default: 0
            }
        },
        computed: {
            ws: function () {
                //return window.wss;
            }
        },
        beforeDestroy() {
            //clearInterval(this.Stat);
        },

        mounted() {

            this.subMatchOdds()

            //setInterval(this.subMatchOdds, 10000);

            if(this.match.sport.sportId != 1){
                this.category = [
                 {name: this.$root.t['all_markets'], id: 0, i: 'icon-grid', collapsed: true}
                ]
            }
            /*
            this.$bus.$on('updatedOdd', (payload) => {
                if (this.odds) {
                    Object.values(this.odds).map(function (item) {

                        Object.values(item.odd).forEach(d => {


                            if (d.id == payload.id) {

                                d.active = (payload.disable) ? 0 : 1;
                                d.change = (d.odd < payload.odd) ? 'odd-down' : 'odd-up';

                                if (d.odd === parseFloat(payload.odd).toFixed(2))
                                    d.change = '';


                                if (payload.disable)
                                    d.change = '';

                                d.odd = parseFloat(payload.odd).toFixed(2);

                                //self.odds[payload.market].odd[payload.id] = null;

                                setTimeout(() => {
                                    if (payload.disable || d.odd == payload.odd)
                                        d.change = '';
                                    this.$forceUpdate();
                                    //console.log(self.odds[payload.market]);
                                }, 2500);
                            }
                        })
                    });
                }


            });
                */
        },
        methods: {
            openMatch(m) {
                this.$bus.$emit('openMatchOdd', m);
            },
            filterMarket(Market) {
                this.marketType = Market;
            },
            ReList() {
                var ReList = []
                for (var key in this.match.odds) {

                    if (!this.match.odds[key].isDisabled) {
                        var Current = this.findByKey(ReList, "market", this.match.odds[key].market)

                        if(!Current){
                            ReList.push({market: this.match.odds[key].market, markets: [], order: this.match.odds[key].order})
                            ReList[ReList.length - 1].markets.push(this.match.odds[key])
                        }
                            
                        if(Current)    
                            Current.markets.push(this.match.odds[key])
                    }
                }

                return ReList
            },
            findMarkets() {
                for (var key in this.match.odds) {
                  for (var mx in this.match.odds[key].markets) {
                    if (this.finded.indexOf(this.match.odds[key].markets[mx]) == -1) {
                      this.finded.push(this.match.odds[key].markets[mx]);
                    }
                  }
                }
              },
            checkFilteredMarket(marketType, markets) {
                if (marketType == 0) {
                    return true;
                } else {

                    if (markets.includes(marketType)) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            onStick (m) {
                this.$emit('onStick', m);
            },
            collapse(c){
              c.collapsed = (c.collapsed) ? false : true;
            },
            async subMatchOdds(m) {

                this.loading = false;
                this.findMarkets();

                if (this.matchId == 0) {
                    //this.odds = [];
                    var th = this;
                    
                    if (this.match.onLive) {
                        //window.scrollTo(0, 150);
                        var state = 'odds';
                        var timestamp = new Date().getTime();
                    } else {
                        var state = 'odds';
                        var timestamp = 0;
                    }

                    this.$http.get(bsapi + 'api/v2/fixture/e/' + th.matchId, {params: {t: timestamp, app: this.$root.app.id, locale: window.locale}}).then(response => {
                        // get body data
                        th.odds = null;
                        th.oddHeader = true;

                        var Event = response.body.result;

                        if(Event.markets) {
                            th.odds = this.marketCompile(Event);
                            //th.markets = response.body.result.markets;
                            th.matchNotfound = false;
                            th.loading = false;
                            th.sid = Event.sport.id;
                        }else {
                            th.currentMarkets = [];
                            th.odds = null;
                            th.empty = true;
                            th.oddStat();
                            th.loading = false;
                        }

                        if(Event.sub > 0 && Event.sub != th.matchId) {
                            this.subEventOdds(Event.sub);
                        }else {
                            th.findMarkets();
                        }



                    }, response => {
                        // error callback
                    })
                }
            },
            async subEventOdds(m) {


                if (this.matchId) {
                    //this.odds = [];
                    var th = this;
                    if (this.match.onLive) {
                        //window.scrollTo(0, 150);
                        var state = 'odds';
                        var timestamp = new Date().getTime();
                    } else {
                        var state = 'odds';
                        var timestamp = 0;
                    }

                    this.$http.get(bsapi + 'api/v2/fixture/e/' + m + '?t=' + timestamp + '&app=' + this.$root.app.id).then(response => {
                        // get body data

                        var SubOdds = this.marketCompile(response.body.result);

                        th.odds = th.odds.concat(SubOdds);

                        th.findMarkets();

                    }, response => {

                    })
                }
            },
            async subMatchOddsOld(m) {

                if (this.matchId) {
                    //this.odds = [];
                    var th = this;
                    if (this.live) {
                        //window.scrollTo(0, 150);
                        var state = 'odds';
                        var timestamp = new Date().getTime();
                    } else {
                        var state = 'odds';
                        var timestamp = 0;
                    }

                    this.$http.get(bsapi + 'api/v1/fixture/' + state + '/' + th.matchId + '?app=' + this.$root.app.id).then(response => {
                        // get body data
                        th.odds = null;
                        th.oddHeader = true;

                        th.odds = response.body.result.odds;
                        th.markets = response.body.result.markets;
                        th.matchNotfound = false;
                        th.loading = false;
                        th.sid = response.body.result.match.sid;
                        th.findMarkets();


                    }, response => {
                        // error callback
                        th.currentMarkets = [];
                        th.odds = null;
                        th.empty = true;
                        th.oddStat();
                        th.loading = false;
                    })
                }
            },
            oddStat() {
                if (this.syncStat) {
                    this.syncStat = false
                    this.$http.get(bsapi + 'api/v1/fixture/odd/stat/' + this.matchId).then(response => {

                        this.syncStat = true

                    }, response => {
                        // error callback

                        this.syncStat = true
                    })
                }

            },
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/odd.vue